import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useThorView } from '@aviv-dxp/react-thor';
import { Box } from '@gemini/core';
import { ListIcon } from '@gemini/icons';
import { Button } from '@gemini/ui';
import { ErrorMapIllu } from '@/assets/icons/ErrorMapIllu';
import { MediumCta } from '@/entities/enums/MediumCta';
import { getMediumAttribute } from '@/helpers/tracking/tracking';
import { useMobileViewDetect } from '@/hooks/useMobileViewDetect/useMobileViewDetect';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import { getPageTitle, useTrackingProps } from '@/hooks/useTrackingProps/useTrackingProps';
import ErrorContent from '../ErrorContent';
export const MapErrorContent = () => {
    const { t } = useShellTranslation();
    const { sidebarOpen, setSidebarOpen, pricePageProps: { pricePageContext: { place }, }, } = usePageLayoutContext();
    const view = useThorView();
    const viewProps = useTrackingProps();
    const { isMobileView } = useMobileViewDetect();
    const handleButtonSwitch = () => {
        view({
            viewProps: {
                ...viewProps,
                av_medium: getMediumAttribute(sidebarOpen ? MediumCta.SWITCH_MAP_VIEW : MediumCta.SWITCH_INFO_VIEW, place.type, place.type),
                // av_pagetitle is calculated with the future value of listView
                av_pagetitle: getPageTitle(place, isMobileView, !sidebarOpen),
            },
        });
        setSidebarOpen((sideBarWasOpen) => !sideBarWasOpen);
    };
    return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "color.background.default", justifyContent: "center", height: "100%", overflowY: "scroll", children: [!sidebarOpen && isMobileView ? (_jsx(Box, { paddingHorizontal: "spacing.16", display: "flex", alignItems: "flex-start", justifyContent: "flex-start", width: "100%", children: _jsx(Button, { icon: ListIcon, iconPosition: "start", variant: "primary-inverted", onPress: () => handleButtonSwitch(), children: t('button_switch.info_view') }) })) : undefined, _jsx(Box, { flexGrow: "1", width: "100%", display: "flex", alignItems: "center", backgroundColor: "color.background.default", justifyContent: "center", height: "100%", paddingHorizontal: "spacing.16", children: _jsx(ErrorContent, { title: t('map.map_error_message.title'), description: `${t('map.map_error_message.general_explanation')} ${t('map.map_error_message.advice')}`, image: ErrorMapIllu }) })] }));
};
